import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import Location from '@solvhealth/types/interfaces/Location';
import Button, { ButtonVariations } from '../../SolvPatternLibrary/Button';
import { OriginType } from '../../../core/util/bookingFlowRoutingTypes';
import { getSkipButtonCopy } from '../util/insuranceForm';
import { isPhotoOnlyInsuranceFlow } from '../../../core/util/location';

const StyledButton = styled(Button)`
  margin-top: 15px;
  margin-left: auto;
  margin-right: auto;
  cursor: pointer;
  text-transform: none;
`;

type Props = {
  handleEnterManually?: (...args: any[]) => any;
  handleSkipBack?: (...args: any[]) => any;
  handleSkipInsurance?: () => void;
  skipBack?: boolean;
  insuranceCard: any;
  location: Location;
  origin: OriginType;
  isMobileFlow: boolean;
  isInsuranceFormPage: boolean;
};

const MainCtaButton = (props: Props) => {
  const {
    skipBack,
    insuranceCard,
    handleSkipBack,
    handleSkipInsurance,
    handleEnterManually,
    location,
    origin,
    isMobileFlow,
    isInsuranceFormPage,
  } = props;

  const { t } = useTranslation(['common', 'addInsurance']);

  const { isInsuranceRequiredForBooking } = location;

  if (skipBack) {
    return null;
  }

  const continueText = t('common:continue.capitalize');

  if (isPhotoOnlyInsuranceFlow(location) && insuranceCard.front.base64) {
    return (
      <StyledButton
        disableRipple
        onClick={handleSkipInsurance}
        variation={ButtonVariations.pinkPrimary}
      >
        {continueText}
      </StyledButton>
    );
  }

  if (insuranceCard.front.base64 && !insuranceCard.back.base64) {
    return (
      <StyledButton disableRipple onClick={handleSkipBack} variation={ButtonVariations.pinkPrimary}>
        {continueText}
      </StyledButton>
    );
  }

  if (!insuranceCard.front.base64 && !insuranceCard.back.base64) {
    return (
      <StyledButton
        data-testid="skipUploadInsurance"
        disableRipple
        id="enter-manually"
        onClick={isPhotoOnlyInsuranceFlow(location) ? handleSkipInsurance : handleEnterManually}
        variation={ButtonVariations.link}
      >
        {getSkipButtonCopy(
          origin,
          isInsuranceRequiredForBooking,
          isMobileFlow,
          isInsuranceFormPage,
          t
        )}
      </StyledButton>
    );
  }

  return null;
};

export default MainCtaButton;
